import * as apiLib from './api';

export const listDonors = async (payload: {
  placeId: string,
  donorNm?: string | null,
  donorDesc?: string | null,
  page: number,
  limit: number,
  accessToken: string,
}) => {
  try {
    const data = { ...payload };

    const result = await apiLib.fetchArchiveApi('/donor/list', data);

    if (result.resultFlag) {
      return result;
    } else {
      throw Object.assign(new Error('listDonors error'), { status: 401 });
    }
  } catch (err) {
    throw err;
  }
};

export const listDonorOfDonation = async (payload: { placeId: string, donorId?: string, accessToken: string }) => {
  try {
    const data = { ...payload };

    const result = await apiLib.fetchArchiveApi('/donor/select-list', data);

    if (result.resultFlag) {
      return result.donationList;
    } else {
      throw Object.assign(new Error('listDonorOfDonation error'), { status: 401 });
    }
  } catch (err) {
    throw err;
  }
};

export const detailDonors = async payload => {
  try {
    const data = {
      ...payload,
    };

    const result = await apiLib.fetchArchiveApi('/donor/detail', data);

    if (result.resultFlag) {
      return result.donorInfo;
    } else {
      throw Object.assign(new Error('donor detail Api Error'), { status: 401 });
    }
  } catch (err) {
    throw err;
  }
};

export const addDonors = async payload => {
  try {
    const data = {
      ...payload,
    };

    const result = await apiLib.fetchArchiveApi('/donor/add', data);

    if (result.resultFlag) {
      return true;
    } else {
      throw Object.assign(new Error('donor Add Api Error'), { status: 401 });
    }
  } catch (err) {
    throw err;
  }
};

export const updateDonors = async payload => {
  try {
    const data = {
      ...payload,
    };

    const result = await apiLib.fetchArchiveApi('/donor/edit', data);

    if (result.resultFlag) {
      return true;
    } else {
      throw Object.assign(new Error('donor update Api Error'), { status: 401 });
    }
  } catch (err) {
    throw err;
  }
};

export const removeDonors = async payload => {
  try {
    const data = {
      ...payload,
    };

    const result = await apiLib.fetchArchiveApi('/donor/remove', data);

    if (result.resultFlag) {
      return true;
    } else {
      throw Object.assign(new Error('donor Remove Api Error'), { status: 401, errorType: result.errorType });
    }
  } catch (err) {
    throw err;
  }
};
